import React, {useEffect, useState} from "react";
import {InformatAccountPickerLoading} from "../../../components/05pages/informat/InformatAccountPickerLoading/InformatAccountPickerLoading";
import {InformatAccountPickerError} from "../../../components/05pages/informat/InformatAccountPickerError/InformatAccountPickerError";
import {IAccount, InformatAccountPicker} from "../../../components/05pages/informat/InformatAccountPicker/InformatAccountPicker";
import {AccountsApi, ExternalLoginAction} from "../../../routing/InformatExternalLinks/InformatExternalLinks";


interface LinkedInformatAccount {
    accountName: string,
    accountDescription: string,
    accountId: string,
    gebruikerId: string,
    pInstallatie: number
    activeState: number
}
interface AccountData {
    givenName: string,
    surname: string,
    accounts: LinkedInformatAccount[]
}

interface IState {
    isLoading: boolean;
    isError: boolean;
    errorMessage: string;
    accountData: AccountData;
}

const defaultAccountData = {givenName: "", surname: "", accounts: []};

export const AccountPicker: React.FC = props => {
    const [state, setState] = useState<IState>({
        isLoading: true,
        isError: false,
        errorMessage: "",
        accountData: defaultAccountData
    })

    const handleError = (e: any) => {
        setState({...state, isError: true, isLoading: false, accountData: defaultAccountData, errorMessage: JSON.stringify(e)})
        console.error(JSON.stringify(e));
    }

    const handleDataLoaded = (data: AccountData) => {
        setState({...state, isError: false, isLoading: false, accountData: data, errorMessage: JSON.stringify("")})
    }


    // Data Loader
    useEffect(() => {(async () => {
        try {
            const response = await fetch(AccountsApi)
            if (response.ok) {
                // Server returned Ok -> Fetching data
                const data = (await response.json()) as AccountData;
                handleDataLoaded(data);
            } else {
                // Server returned an error
                handleError(response.body)
            }
        } catch (e) {
            // Something went very wrong
            handleError(e.message);
        }
    })()}, []);


    // Account selection forwarder
    const accountSelected = (account: IAccount) => {
        const selectedAccount = state.accountData.accounts.find(a => a.accountId == account.accountId);
        if (selectedAccount)
        {
            ExternalLoginAction(selectedAccount.pInstallatie, selectedAccount.gebruikerId)
        } else {
            console.error(`Account not found: ${JSON.stringify(account)}`);
        }
    }

    return state.isError
        ? <InformatAccountPickerError errorMessage={state.errorMessage} />
        : state.isLoading
            ? <InformatAccountPickerLoading />
            : <InformatAccountPicker
                    userFirstName={state.accountData.givenName}
                    accounts={state.accountData.accounts.map(acc => {
                        return {
                            accountLogin: acc.accountName,
                            accountName: acc.accountDescription,
                            isDisabled: acc.activeState == -1,
                            isLocked: acc.activeState == 0,
                            accountId: acc.accountId
                        }
                    })}
                    onClick={accountSelected} />
}
